<template>
    <router-view :key="$route.fullPath" />
</template>

<script lang="ts">
import Vue from 'vue';
import { useAuthEspecialidade } from '@/composables/useAuthEspecialidade';

export default Vue.extend({
  name: 'App',
  setup() {
    const { aplicarEspecialidadeDoUsuario } = useAuthEspecialidade();
    return {
      aplicarEspecialidadeDoUsuario,
    };
  },
  mounted() {
    this.aplicarEspecialidadeDoUsuario();
  },
});
</script>

<style>
@font-face {
    font-family: 'New SEC APP';
    src: url('./assets/fonts/SecApp.ttf') format('truetype');
}

html {
    font-family: 'New SEC APP';
    background-color: rgba(138, 147, 172, 0.2) ;
}

body {
    font-family: 'New SEC APP';
}

.swal2-popup {
    font-family: 'New SEC APP';
}

.swal-popup-default-size .swal2-title {
    font-size: 1.25rem !important;
}

.swal-popup-default-size .swal2-html-container {
    font-size: 1rem !important;
}

.v-card {
    border-radius: 0.5rem !important;
    margin: 1.875rem;
}
</style>
